const RetailSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            {/* <div className="col-lg-6">
              <div className="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img className="dark" src="/assets/images/new/retail.webp" alt="Retail Investor" />
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-lg-12">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">Retail <span className="style2">Investors</span></h2>
                  <p>
                    Individual investors benefit from easy onboarding, intuitive tools, and SIP options—empowering disciplined, long-term wealth building with minimal barriers to entry.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-30">
                <div className="benefits-section" data-aos="fade-up" data-aos-duration="800">
                    <div className="benefits-inner">
                        <h3 className="benefits-title">Key Characteristics</h3>

                        <div className="benefits-list">

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Individual Investors</h5>
                            <p className="benefit-text">
                                Retail investors are individuals, not organizations.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Personal Accounts</h5>
                            <p className="benefit-text">
                                They invest their own money for personal financial goals.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Smaller Capital</h5>
                            <p className="benefit-text">
                                Compared to institutional investors, they manage smaller amounts of capital.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Accessibility</h5>
                            <p className="benefit-text">
                                They use online trading platforms and apps to participate in the market.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Broad Range of Knowledge</h5>
                            <p className="benefit-text">
                                This group includes both novice investors and experienced traders.
                            </p>
                            </div>
                        </div>

                        </div>

                    </div>
                </div>
            </div>
            <div className="col-lg-12 mt-30">
                <div className="about__content">
                    <div className="about__content-inner">
                    <h3 className="text-center" data-aos="fade-right" data-aos-duration="500">Retail Investor Profile</h3>
                    
                    <div className="platform-features">
                        <div className="feature-card" data-aos="fade-left" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-money-bill-wave"></i>
                        </div>
                        <div className="feature-title">Investment Size</div>
                        <div className="feature-desc">Typically ranges from a few hundred to tens of thousands of dollars</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-down" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-chart-pie"></i>
                        </div>
                        <div className="feature-title">Common Investments</div>
                        <div className="feature-desc">Stocks, bonds, ETFs, mutual funds, and cryptocurrencies</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-right" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-bullseye"></i>
                        </div>
                        <div className="feature-title">Primary Motivation</div>
                        <div className="feature-desc">Long-term wealth building, retirement savings, and financial independence</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-left" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-exclamation-triangle"></i>
                        </div>
                        <div className="feature-title">Risk Tolerance</div>
                        <div className="feature-desc">Varies widely from conservative to aggressive depending on the individual</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-up" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-clock"></i>
                        </div>
                        <div className="feature-title">Time Horizon</div>
                        <div className="feature-desc">Typically medium to long-term (5+ years)</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-right" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-user"></i>
                        </div>
                        <div className="feature-title">Profile Type</div>
                        <div className="feature-desc">Individual investors managing personal portfolios for personal goals</div>
                        </div>
                    </div>
                    
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetailSection;